// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1_Eup","header":"MergedInvoice_header__13BI0"};